// extracted by mini-css-extract-plugin
export default {"amountContainer":"DollarAmount_amountContainer__vu7-Y","sign":"DollarAmount_sign__IRBHZ","alignCenter":"DollarAmount_alignCenter__4DDWR","alignLeft":"DollarAmount_alignLeft__xMEHN"};